<template>
  <div class="card">
    <card-m title="资料详情进度" cardWidth="97%"  cardHeight="97%" maxHeight="100%">
      <template slot="card-box">
        <cardTable
          :total="totalCounts"
          :tableColumn="column"
          :tableData="tableData"
          :loading="loading"
          :showPaging='false'
        >
        </cardTable>
      </template>
    </card-m>
  </div>
</template>

<script>
import { apiMain, apiMainMultiple } from '@/api/mainapi.js';
import { convertDateFormat } from '@/utils/tools.js';
export default {
  //components: { cardTable },
  name: 'card-M',
  props: {
    contractId:String
  },
  data() {
    return {
      totalCounts:0,
      column:[
        {
          
          prop: '类型',
          label: '类型'
        
        },
        {
          prop: 'finish',
          label: '完成情况',
          custom: true,
          column: {
            type: 'icon',
            field: 'finish',
            icon:{
              success:"el-icon-check",
              unsuccess:"el-icon-minus"
            }
          }
        },
        {
          
          prop: 'field0019',
          label: '预计增补'

        },
        {
          
          prop: 'field0018',
          label: '数量'
        
        },
        {
          
          prop: 'field0022',
          label: '时间'
        
        },
        {
          
          prop: 'field0023',
          label: '人员'
        
        }
      ],
      tableData:[],
      loading:false,
    };
  },
  mounted(){

  },
  methods: {
    async getTableData(id) {
      const params = {
        Type: 'DesignProgress',
        contractNo: id
      };
      const res = await apiMain(params);
     
      // debugger
      if(res.data.data.length){
        this.tableData = res.data.data
        this.tableData.forEach((item)=>{
          if(item.field0022){
            item.field0022 = convertDateFormat(item.field0022)
          }
          
        })
      }
      let finishArr = []
       res.data.data.forEach((item)=>{
        if(item.finish){
          finishArr.push(item)
        }
       })
      if (finishArr.length) {
        this.$emit("setCurrentProgress",true)
      }else{
        this.$emit("setCurrentProgress",false)
      }
    }
  }
};
</script>

<style scoped scoped lang="scss">
.card{
  width: 100%;
  height: 100%;
}
</style>
